import { jsx, jsxs } from "react/jsx-runtime";
import { cleanProps, cn } from "../../utils/index.js";
import { priceVariants } from "./Price.variants.js";
function Price({ className, price, currencySymbol, currencyCode, isFormatted = false, type, textStyle, emphasis = 'regular', bold = false, prefix, suffix, isStrike = false, isMinusSign = false, ...props }) {
    const { base, currencyCodeSlot, currencySymbolSlot, priceSlot, priceWholeSlot, priceDecimalSlot, priceStrikeSlot, prefixSlot, suffixSlot } = priceVariants({
        ...props,
        type,
        textStyle,
        emphasis,
        bold,
        isFormatted,
        isStrike
    });
    const classes = cn(base(), className);
    const splitPrice = price.split('.');
    const priceWhole = splitPrice[0];
    const priceDecimal = splitPrice[1] && `.${splitPrice[1]}`;
    return /*#__PURE__*/ jsxs("div", {
        className: classes,
        ...cleanProps(props, [
            'type',
            'textStyle',
            'emphasis'
        ]),
        children: [
            /*#__PURE__*/ jsx("span", {
                className: prefixSlot(),
                children: prefix
            }),
            isMinusSign && /*#__PURE__*/ jsx("span", {
                children: "-"
            }),
            /*#__PURE__*/ jsx("span", {
                className: currencyCodeSlot(),
                children: currencyCode
            }),
            /*#__PURE__*/ jsx("span", {
                className: currencySymbolSlot(),
                children: currencySymbol
            }),
            /*#__PURE__*/ jsxs("div", {
                className: priceSlot(),
                children: [
                    /*#__PURE__*/ jsx("span", {
                        className: priceWholeSlot(),
                        children: priceWhole
                    }),
                    /*#__PURE__*/ jsx("span", {
                        className: priceDecimalSlot(),
                        children: priceDecimal
                    }),
                    /*#__PURE__*/ jsx("span", {
                        className: priceStrikeSlot()
                    })
                ]
            }),
            /*#__PURE__*/ jsx("span", {
                className: suffixSlot(),
                children: suffix
            })
        ]
    });
}
export { Price };
